/* eslint-disable react-refresh/only-export-components */
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { clearSession, getSessionExpiresAt, getSessionId } from '../api/sessionStore';

interface SessionContextValue {
  isAuthenticated: boolean;
  /** Unix ms; null pokud není přihlášený nebo BE expiraci neposlal. */
  expiresAt: number | null;
  setAuthenticated: (v: boolean, expiresAt?: number) => void;
}

const SessionContext = createContext<SessionContextValue | undefined>(
  undefined
);

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    () => !!getSessionId()
  );
  const [expiresAt, setExpiresAt] = useState<number | null>(() =>
    getSessionExpiresAt()
  );

  const setAuthenticated = useCallback((v: boolean, expAt?: number) => {
    if (v) {
      if (expAt !== undefined) setExpiresAt(expAt);
    } else {
      // při ztrátě session (logout, 401, auto-expiry) zahodíme i sessionId + expiraci
      clearSession();
      setExpiresAt(null);
    }
    setIsAuthenticated(v);
  }, []);

  const value = useMemo(
    () => ({ isAuthenticated, expiresAt, setAuthenticated }),
    [isAuthenticated, expiresAt, setAuthenticated]
  );

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
}

export function useSession(): SessionContextValue {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used within SessionProvider');
  return ctx;
}
